export default {
  code: 'Код',
  description: 'Описание',
  missing_permissions: 'Отсутствующие права доступа',
  parameter: 'Параметр',
  traceback: 'Отладочная информация'
};
